import { createSelector } from 'reselect';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';

const experianStateSelector = state => state.experian;

export const reportsSelector = createSelector(
  experianStateSelector,
  ({ reports }) => reports,
);

export const reportSelector = createSelector(
  reportsSelector,
  currentRouteSelector,
  (reports, { params: { subscriberId } }) => reports[subscriberId],
);

export const enrollmentStatusSelector = createSelector(
  reportSelector,
  report => (report ? report.ExperianSubscriber.EnrollmentStatus : null),
);

export const enrollmentErrorSelector = createSelector(
  reportSelector,
  report => (report ? report.ExperianSubscriber.ErrorDescription : null),
);

export const darkWebDataSelector = createSelector(
  reportSelector,
  report => (report ? report.MonitoredCyberInformation : null),
);

export const hasMoreActiveAlertsSelector = createSelector(
  reportSelector,
  report => (report ? report.hasMoreActiveAlerts : null),
);

export const hasMoreArchivedAlertsSelector = createSelector(
  reportSelector,
  report => (report ? report.hasMoreArchivedAlerts : null),
);
